/* Khoi goi y o gio hang. Nap tu snippets/cart-drawer.liquid NGOAI moi dieu kien,
   de co mat tu lan tai trang dau ke ca khi gio trong. Script nam trong HTML duoc
   theme va vao sau khi Add se KHONG bao gio chay, nen khong duoc de inline trong snippet. */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!customElements.get('cart-upsell')) {
  /*
    Doi mon theo CHI SO, khong dung cuon ngang.
    Ban truoc dung scroll-snap + nhay scrollLeft de lap vong: Safari iOS xu ly khac
    desktop, bam mui ten ra o trang. Cach nay khong co scrollLeft nao de sai.

    CHONG MORPH: theme va DOM tai cho sau Add nen connectedCallback khong chay lai.
    Moi listener gan vao chinh <cart-upsell>, khoi tao lai qua MutationObserver.
    Trang thai (chi so dang hien) luu trong data-i cua .cup__row.
  */
  class CartUpsell extends HTMLElement {
    connectedCallback() {
      if (!this._daGan) {
        this._daGan = true;

        this.addEventListener('click', (e) => {
          const nav = e.target.closest('.cup__nav');
          if (nav) { this.buoc(nav.closest('.cup__row'), Number(nav.dataset.di) || 1); return; }
          const opt = e.target.closest('.cup__opt');
          if (opt) { this.chon(opt); return; }
          const btn = e.target.closest('.cup__add');
          if (btn) this.them(btn);
        });

        /* Vuot tay: chi bat khi keo ngang ro rang, de khong can cuon doc cua ngan keo */
        this.addEventListener('touchstart', (e) => {
          const row = e.target.closest('.cup__row');
          if (!row || e.target.closest('.cup__add, .cup__opt')) { this._vuot = null; return; }
          const t = e.touches[0];
          this._vuot = { row, x: t.clientX, y: t.clientY };
        }, { passive: true });
        this.addEventListener('touchend', (e) => {
          const v = this._vuot; this._vuot = null;
          if (!v) return;
          const t = e.changedTouches[0];
          const dx = t.clientX - v.x, dy = t.clientY - v.y;
          if (Math.abs(dx) > 36 && Math.abs(dx) > Math.abs(dy) * 1.3) this.buoc(v.row, dx < 0 ? 1 : -1);
        }, { passive: true });
      }
      /* 19/10 chieu: theo doi CA thuoc tinh class. Doi so luong o gio chi lam theme va lai class
         (xoa is-ready / is-on) ma khong them bot node nao; truoc day observer chi nghe childList nen
         khong khoi tao lai, hang mat is-ready, lan bam tiep theo hien 2 mon cung luc.
         Goi thang trong callback (microtask, truoc khi ve) chu khong doi rAF, de khong nhay mon dau 1 khung hinh. */
      this._nho = this._nho || new Map();
      this._qs = new MutationObserver(() => this.khoiTao());
      this._qs.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      this.khoiTao();
    }

    disconnectedCallback() {
      this._qs?.disconnect();
    }

    /* Idempotent. Lan dau: mon ngau nhien. Sau khi theme va lai: giu mon + bien the khach dang xem
       (nho theo data-k cua hang), mon do vua bi them vao gio thi hien mon ke tiep cung vi tri. */
    khoiTao() {
      this.querySelectorAll('.cup__row').forEach((row) => {
        const slots = row.querySelectorAll('.cup__slot');
        const n = slots.length;
        row.querySelectorAll('.cup__nav').forEach((b) => (b.hidden = n < 2));
        if (!n) return;
        /* dau theo san pham (data-p), KHONG theo variant: doi bien the lam doi chu gia, observer goi lai day,
           neu dau theo variant thi hang se nhay sang mon khac */
        const dau = n + ':' + [...slots].map((s) => s.dataset.p || '').join(',');
        if (row.dataset.dau === dau && row.classList.contains('is-ready')) return;
        row.dataset.dau = dau;
        const nho = this._nho.get(row.dataset.k);
        let i = Math.floor(Math.random() * n);
        if (nho) {
          const k = [...slots].findIndex((s) => s.dataset.p === nho.p);
          i = k >= 0 ? k : nho.i;
          slots.forEach((s) => {
            const v = nho.v[s.dataset.p];
            const opt = v && s.querySelector(`.cup__opt[data-v="${v}"]`);
            if (opt) this.chon(opt);
          });
        }
        this.hien(row, i);
      });
    }

    hien(row, i) {
      const slots = row.querySelectorAll('.cup__slot');
      const n = slots.length;
      if (!n) return;
      i = ((i % n) + n) % n;              /* vong tron ca hai chieu */
      slots.forEach((s, k) => s.classList.toggle('is-on', k === i));
      row.dataset.i = i;
      row.classList.add('is-ready');
      if (row.dataset.k) {
        const nho = this._nho.get(row.dataset.k) || { v: {} };
        nho.i = i; nho.p = slots[i].dataset.p;
        this._nho.set(row.dataset.k, nho);
      }
    }

    buoc(row, d) {
      if (!row || row.dataset.dangDoi) return;
      row.dataset.dangDoi = '1';
      row.classList.add('is-fading');
      setTimeout(() => {
        this.hien(row, Number(row.dataset.i || 0) + d);
        row.classList.remove('is-fading');
        delete row.dataset.dangDoi;
      }, 110);
    }

    /* Chon bien the: doi id tren nut Add, gia, % off, anh */
    chon(opt) {
      const slot = opt.closest('.cup__slot');
      if (!slot || opt.getAttribute('aria-pressed') === 'true') return;
      const k = slot.closest('.cup__row')?.dataset.k;
      if (k) {
        const nho = this._nho.get(k) || { v: {} };
        nho.v[slot.dataset.p] = opt.dataset.v;
        this._nho.set(k, nho);
      }
      slot.querySelectorAll('.cup__opt').forEach((o) => o.setAttribute('aria-pressed', o === opt ? 'true' : 'false'));
      const btn = slot.querySelector('.cup__add');
      if (btn) {
        btn.dataset.variant = opt.dataset.v;
        btn.setAttribute('aria-label', `Add ${btn.dataset.name || ''}, ${opt.title} to cart, ${opt.dataset.pr}`);
      }
      const b = slot.querySelector('.cup__price b');
      if (b) b.textContent = opt.dataset.pr;
      const off = slot.querySelector('.cup__off');
      const g = Number(opt.dataset.g) || 0;
      if (off) { off.hidden = g < 5; off.textContent = g + '% off'; }
      const img = slot.querySelector('.cup__media img');
      if (img && opt.dataset.img && !img.src.includes(opt.dataset.img.split('?')[0])) {
        img.removeAttribute('srcset');
        img.src = opt.dataset.img;
      }
    }

    async them(btn) {
      const id = btn.dataset.variant;
      if (!id || btn.disabled) return;
      const o = btn.querySelector('.cup__add-txt') || btn;
      const chu = o.textContent;
      btn.disabled = true;
      btn.classList.add('is-busy');
      o.textContent = 'Adding';

      const routes = (window.Theme && Theme.routes) || {};
      const addUrl = routes.cart_add_url || '/cart/add.js';
      const cartUrl = routes.cart_url || '/cart';
      const lines = [{ id: Number(id), quantity: 1 }];

      const deferred = CartLinesUpdateEvent.createPromise();
      this.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'cart-upsell',
          lines: lines.map((l) => ({ merchandiseId: String(l.id), quantity: l.quantity })),
          promise: deferred.promise,
        })
      );

      try {
        /* 18/10: ask for the drawer HTML in the same request (Section Rendering API), so the drawer
           morphs from this response instead of firing one more request after it. */
        const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')]
          .map((el) => el.dataset.sectionId).filter((v, i, a) => v && a.indexOf(v) === i);
        const res = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: lines, sections: sectionIds.join(','), sections_url: location.pathname }),
        });
        const data = await res.json();
        if (data.status) throw new Error(data.description || data.message || 'Add to cart failed');
        const cart = await (await fetch(`${cartUrl}.js`)).json();
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { sections: data.sections, items: cart.items, source: 'cart-upsell' } });
      } catch (err) {
        deferred.resolve({ detail: { didError: true } });
        console.warn('[cart-upsell]', err);
        btn.disabled = false;
        btn.classList.remove('is-busy');
        o.textContent = chu;
      }
    }
  }
  customElements.define('cart-upsell', CartUpsell);
}
